// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a693ed85","952":"6b739334"}[chunkId] + ".chunk.js";
};